// 引用接口返回值处理文件
import Vue from 'vue'
import { Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import handling from './error.js'
import utils from '@/utils'
import { getCookie } from '@/store/cookies.js'
// 引用axios
var axios = require('axios')
var failure = handling.failureHandling
// 判断参数是否为空对象
function isEmptyObject (obj) {
  for (var key in obj) {
    return false// 返回false，不为空对象
  }
  return true// 返回true，为空对象
}
// Token参数处理函数
function dealToken (type, o) {
  if (isEmptyObject(o)) {
    o = {}
  }
  var r
  var d = utils.getQueryString('domain')
  if (!d) {
    d = 'inesa'
  }
  if (window.location.hostname == 'localhost') {
    if (window.location.hash.split('/')[1] == 'continueEdu') {
      d = 'inesajxjy' // xja(公开机构) sun098(非公开机构), inesajxjy
    } else if (window.location.hash.split('/')[1] == 'entrain') {
      d = 'hsm' // 1010, hsm
    } else {
      d = 'inesa'
    }
  }
  if (type === 'POST') {
    r = {
      data: o,
      token: {
        token: getCookie('token'),
        domain: d
      }
    }
    return r
  } else if (type === 'GET' || type === 'DELETE' || type === 'PUT') {
    o.token = getCookie('token')
    o.domain = d
    return o
  }
}
/*
  接口处理函数
*/
function apiAxios (method, baseURL, url, params, success, error) {
  var d = {}
  if (params instanceof FormData) { // 如果要使用formdata
    params = dealToken(method, params)
    d = {
      method: method,
      url: url,
      data: method === 'POST' ? params.data : null,
      params: (method === 'GET') ? params : params.token,
      baseURL: baseURL,
      withCredentials: false,
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  } else {
    params = dealToken(method, params)
    d = {
      method: method,
      url: url,
      data: method === 'POST' ? params.data : null,
      params: (method === 'GET') ? params : params.token,
      baseURL: baseURL,
      withCredentials: false
    }
  }
  axios(d)
    .then(function (res) {
      if (res.data.result === 'Success') {
        if (success) {
          success(res.data)
        }
      } else if (res.data.result === 'Error') {
        if (error) {
          error(res.data.message)
        } else {
          failure(res.data.message)
        }
      }
    })
    .catch(function (err) {
      if (err) {
        console.log(err)
      }
    })
}
function apiAxiosRestful (method, baseURL, url, params, success, error) { // RESTFUL风格使用
  params = dealToken(method, params)
  axios({
    method: method,
    url: url,
    data: method === 'POST' ? params.data : null,
    params: method === 'GET' ? params : params.token,
    baseURL: baseURL,
    withCredentials: false
  })
    .then(function (res) {
      if (res.data.result === 'Success') {
        if (success) {
          success(res.data)
        }
      } else if (res.data.result === 'Error') {
        if (error) {
          error(res.data.message)
        } else {
          failure(res.data.message)
        }
      }
    })
    .catch(function (err) {
      if (err) {
        console.log('error:' + err)
      }
    })
}

let loading;
let needLoadingRequestCount = 0; // 声明一个对象用于存储请求个数
function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
};
function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    utils.debounce(endLoading, 300)()
  }
};
function startLoading () {
  loading = Loading.service({
    lock: true,
    spinner: 'byl-loading',
    text: "努力加载中...",
    background: "transparent"
    // target: document.querySelector('.loadingtxt') // 控制显示范围，还有bug
  });
}
function endLoading () {
  if (needLoadingRequestCount === 0) {
    loading.close()
  }
}
axios.interceptors.request.use(
  (config) => {
    // 所有请求之前都要执行的操作
    // 根据接口传入参数显示加载动画
    // console.log(window.location.hash.split('?')[0])
    if (window.location.hash.split('?')[0] !== '#/byl/orgreg' &&
      window.location.hash.split('?')[0] !== '#/byl/wxPay' &&
      (window.location.hash.split('/')[1] + '/' +   window.location.hash.split('/')[2] == 'byl/courseDetail')) { // 微信支付页面会不停调取接口，故不再页面上显示loading动画
      // console.log('ddd')
      showFullScreenLoading();
    }
    return config;
  }, function (err) {
    // 暂停加载动画
    tryHideFullScreenLoading();
    return Promise.reject(err);
  }
);
// http response 拦截器
axios.interceptors.response.use((response) => {
  // 所有请求完成后都要执行的操作
  // 暂停加载动画
  tryHideFullScreenLoading();
  return response;
}, function (err) {
  // 暂停加载动画
  tryHideFullScreenLoading();
  return Promise.reject(err);
});

// 返回在vue模板中的调用接口

export default {
  get: function (baseURL, url, params, success, error) {
    return apiAxios('GET', baseURL, url, params, success, error)
  },
  getRestful: function (baseURL, url, params, success, error) {
    return apiAxiosRestful('GET', baseURL, url, params, success, error)
  },
  post: function (baseURL, url, params, success, error) {
    return apiAxios('POST', baseURL, url, params, success, error)
  },
  put: function (baseURL, url, params, success, error) {
    return apiAxios('PUT', baseURL, url, params, success, error)
  },
  delete: function (baseURL, url, params, success, error) {
    return apiAxios('DELETE', baseURL, url, params, success, error)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js